import React from 'react';

import { BVShimmer } from '../../../models/BVShimmers/BVShimmer';

import './bv-shimmer-group.scss';

interface IBVShimmerGroup extends BVShimmer { }

const BVShimmerGroup: React.FunctionComponent<IBVShimmerGroup> = ({ style }) => (
    <div className="bv-shimmer-group" style={style}>
        <div className="shimmer-wrapper">
            <div className="shimmer-price shimmer-price-retail">
                <div className="shimmer-line shimmer-animation"></div>
            </div>
            <div className="shimmer-price">
                <div className="shimmer-line shimmer-animation"></div>
            </div>
        </div>
    </div>
);

export default BVShimmerGroup;